import {Datacenter} from "./datacenter";
import {MapLine, MapPolygon} from "./summary";
import {MapboxUser} from "./mapbox-user";
import {UserMapFileModel} from "./user-map-file";
import {DatacenterV2, Trackeable} from "./datacenter-v2";
import {Provider} from "./providers";
import {MapLabelModel} from "./map-label";

export interface UserMap extends Trackeable {
  mapId?: string; // TODO: Delete mapId after dynamoDB migration to MongoDB
  _id?: string;
  userId?: string;
  mapName: string;
  creationDate?: Date
  modificationDate?: Date
  modifiedBy?: string;
  desc?: string;
  mapTypes?: MapType[];
  units?: DistanceUnits;
  mapLines?: MapLine[];
  mapPolygons?: MapPolygon[];
  datacenters?: DatacenterV2[];
  mwThreshold?: number;
  defaultColor?: string;
  polygons?: string;
  providers?: Provider[],
  defaultFont?: string;
  sharedWith?: MapboxUser[];
  shared?: boolean;
  owner?: string;
  files?: UserMapFileModel[];
  folderId?: string;
  currentFolderId?: string;
  mapLabels?: MapLabelModel[];
  status?: number; // 0 = processing, 1 = ready, 2 = error
  errorMsg?: string; // Error message when status = 2
}

export enum DistanceUnits {
  MILES = 'miles', KMS = 'kilometers'
}

export enum MapType {
  METRO_CARD = 'Metro Card',
  INVESTOR_PRESENTATION = 'Investor Presentation',
  EXECUTIVE_LEADERSHIP = 'Executive Leadership',
  GLOBAL = 'Global',
  EXTERNAL = 'External',
  CLIENT = 'Client',
  SALES_PRESENTATION = 'Sales Presentation'
}

